export function roundDecimal(value, decimalPlaces = 2) {
  var pow = Math.pow(10, Math.max(decimalPlaces, 0));
  return Math.round(value * pow) / pow;
}

export function truncateDecimal(value, decimalPlaces = 2) {
  var pow = Math.pow(10, Math.max(decimalPlaces, 0));
  return Math.trunc(value * pow) / pow;
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

export function moduloWrap(value, modulus) {
  return ((value % modulus) + modulus) % modulus;
}

export const toRadians = degrees => (degrees * Math.PI) / 180;

export const rotateBox = ({width, height}, angle) => ({
  height:
    height * Math.abs(Math.cos(angle)) + width * Math.abs(Math.sin(angle)),
  width: width * Math.abs(Math.cos(angle)) + height * Math.abs(Math.sin(angle))
});

export const getUnrotatedDimensions = ({
  height: _height,
  width: _width,
  originalWidth,
  originalHeight,
  rotation
}) => {
  const radiansRotation = toRadians(rotation);
  const {height: newHeight, width: newWidth} = rotateBox(
    {
      width: originalWidth,
      height: originalHeight
    },
    radiansRotation
  );
  const scaleX = _width / newWidth;
  const scaleY = _height / newHeight;
  return {
    naturalHeight: originalHeight * scaleY,
    naturalWidth: originalWidth * scaleX
  };
};
